import { render, staticRenderFns } from "./SampleAction.vue?vue&type=template&id=04bb85ac&scoped=true&"
import script from "./SampleAction.vue?vue&type=script&lang=ts&"
export * from "./SampleAction.vue?vue&type=script&lang=ts&"
import style0 from "./SampleAction.vue?vue&type=style&index=0&id=04bb85ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb85ac",
  null
  
)

export default component.exports